import _ from 'lodash';
import { observable, action, computed } from 'mobx';

import songsStore from './songs-store';

export default class Playlist {
	store = null;

	constructor (store, data) {
		this.store = store;

		if (_.isEmpty(data)) {

			return;
		}

		this.update(data);
	}

	_id = null;

	get id () {
		return this._id;
	}

	set id (id) {
		this._id = id;
	}

	_imageSavePath = '';

	get imageSavePath () {
		return this._imageSavePath;
	}

	set imageSavePath (imageSavePath) {
		this._imageSavePath = imageSavePath;
	}

	/**
	 * Observables & Computeds
	 */

	@observable
	_title = '';

	@computed
	get title () {
		return this._title;
	}

	set title (title) {
		this._title = title;
	}

	@observable
	_songs = [];

	@computed
	get songs () {
		let loaded = [];
		this._songs.forEach((s) => {
			console.log(s);
			let song = songsStore.getSongByID(s);
			loaded.push(song);
		})
		return loaded;
	}

	set songs (songs) {
		this._songs = songs;
	}

	@observable
	_type = 'SONGS';

	@computed
	get type () {
		return this._type;
	}

	set type (type) {
		this._type = type;
	}

	@observable
	_genre = '';

	@computed
	get genre () {
		return this._genre;
	}

	set genre (genre) {
		this._genre = genre;
	}

	@observable
	_showOnFrontPage = false;

	@computed
	get showOnFrontPage () {
		return this._showOnFrontPage;
	}

	set showOnFrontPage (showOnFrontPage) {
		this._showOnFrontPage = showOnFrontPage;
	}

	@observable
	_position = -1;

	@computed
	get position () {
		return this._position;
	}

	set position (position) {
		this._position = position;
	}

	@observable
	_artwork = '';

	@computed
	get artwork () {
		return this._artwork;
	}

	set artwork (artwork) {
		this._artwork = artwork;
	}

	@observable
	_tags = '';

	@computed
	get tags () {
		return this._tags;
	}

	set tags (tags) {
		this._tags = tags;
	}

	@computed
	get serialized () {
		return {
			_id: this._id,
			title: this.title,
			songs: this.songs,
			type: this.type,
			genre: this.genre,
			showOnFrontPage: this.showOnFrontPage,
			position: this.position,
			artwork: this.artwork,
			tags: this.tags,
			// api expects field name to be "path"
			path: this.imageSavePath,
			userID: this.userID
		};
	}

	/**
	 * Actions
	 */

	@action.bound
	update ({
		_id,
		title,
		songs,
		type,
		genre,
		showOnFrontPage,
		position,
		artwork,
		tags,
		userID
	}) {

		this._id = _id;
		this.title = title;
		this.songs = songs;
		this.type = type;
		this.genre = genre;
		this.showOnFrontPage = showOnFrontPage;
		this.position = position;
		this.artwork = artwork;
		this.tags = tags;
		this.userID = userID;
	}

	@action.bound
	async save (opts) {
		await this.store.savePlaylist(this, opts);
	}

	@action.bound
	async delete () {
		await this.delete(this);
	}

	@action.bound
	addSong ({ id }) {
		this.songs.unshift(id);
	}

	@action.bound
	removeSong ({ id }) {
		this.songs = this.songs.filter((songID) => songID !== id);
	}
}
